import React, { useState } from 'react';
import DashboardLayout from './DashboardLayout';
import ReducedContent from './ReducedContent';
import { Alert } from 'react-bootstrap';
import { submitSurvey } from '../../api/api';

const surveyQuestions = [
    {
        id: 'q1',
        text: 'Ao entrar na plataforma pela primeira vez, ficou claro para você o que era possível fazer?',
        type: 'Escala',
        options: ['1 (Nada claro)', '2', '3', '4', '5 (Muito claro)'],
    },
    {
        id: 'q2',
        text: 'Você já utilizou alguma das funcionalidades abaixo na plataforma?',
        type: 'Múltipla escolha',
        options: [
            'Criar atividade',
            'Criar categoria',
            'Buscar materiais',
            'Salvar materiais',
            'Nenhuma ainda',
        ],
    },
    {
        id: 'q3',
        text: 'Como foi sua experiência ao criar uma atividade na plataforma?',
        type: 'Única escolha',
        options: ['Muito fácil', 'Fácil', 'Neutra', 'Difícil', 'Muito difícil'],
        condition: (answers) => answers['q2'] && answers['q2'].includes('Criar atividade'),
    },
    {
        id: 'q4',
        text: 'O que mais te ajudou no processo de criar uma atividade? Qual dificuldade você teve?',
        type: 'Resposta aberta',
        condition: (answers) => answers['q2'] && answers['q2'].includes('Criar atividade'),
    },
    {
        id: 'q5',
        text: 'As categorias e formas de organização atuais atendem bem sua necessidade?',
        type: 'Única escolha',
        options: ['Sim, totalmente', 'Em parte', 'Não'],
        condition: (answers) => answers['q2'] && answers['q2'].includes('Criar atividade'),
    },
    {
        id: 'q6',
        text: 'O que você sentiu falta? Como reorganizaria essa funcionalidade para atender melhor essa função?',
        type: 'Resposta aberta',
        condition: (answers) => answers['q5'] === 'Não' || answers['q5'] === 'Em parte',
    },
    {
        id: 'q7',
        text: 'O que você mudaria ou adicionaria na forma de organizar materiais?',
        type: 'Resposta aberta',
        condition: (answers) => answers['q2'] && answers['q2'].includes('Buscar materiais'),
    },
    {
        id: 'q9',
        text: 'Em qual situação abaixo a plataforma te ajudou mais?',
        type: 'Múltipla escolha',
        options: [
            'Planejar aulas da semana',
            'Encontrar atividades prontas rapidamente',
            'Organizar materiais que já uso',
            'Trocar ideias com outros professores',
            'Criar atividades do zero com apoio',
            'Outra:',
        ]
    },
    {
        id: 'q8',
        text: 'O quanto a plataforma já te ajuda no preparo das aulas?',
        type: 'Escala',
        options: ['1 (Indiferente)', '2', '3', '4', '5 (Extremamente Relevante)'],
        condition: (answers) => answers['q9'] && answers['q9'].includes('Planejar aulas da semana'),
    },
    {
        id: 'q10',
        text: 'Descreva seu processo atual para encontrar e selecionar materiais didáticos para suas aulas do ensino fundamental. Quais são os maiores desafios que você enfrenta nessa busca?',
        type: 'Resposta aberta',
    },
    {
        id: 'q11',
        text: 'Como você atualmente organiza e armazena seus planos de aula e materiais de ensino? Quais aspectos desse processo são mais frustrantes ou tomam mais tempo?',
        type: 'Resposta aberta',
    },
    {
        id: 'q12',
        text: 'De que forma você costuma colaborar ou trocar ideias e materiais com outros professores? Quais são as limitações ou dificuldades dessas interações?',
        type: 'Resposta aberta',
    },
    {
        id: 'q13',
        text: 'Quão importante é para você ver avaliações ou comentários de outros professores sobre um material antes de utilizá-lo em sua aula?',
        type: 'Única escolha',
        options: ['Muito', 'Em parte', 'Não faço questão', 'Ainda não usei'],
    },
    {
        id: 'q14',
        text: 'Que tipo de incentivos ou recursos comunitários o(a) encorajariam a contribuir com seus próprios materiais e planos de aula para um repositório compartilhado?',
        type: 'Resposta aberta',
    },
    {
        id: 'q15',
        text: 'Com que frequência você sente dificuldade em encontrar materiais didáticos complementares prontos e adequados para suas aulas do ensino fundamental?',
        type: 'Única escolha',
        options: ['Acho fácil', 'Acho com certa dificuldade', 'Acho com muito dificuldade', 'Não acho'],
    },
    {
        id: 'q16',
        text: 'Em média, quantas horas por semana você dedica à busca ou criação de materiais didáticos complementares do zero para suas aulas?',
        type: 'Única escolha',
        options: ['Menos de 1 hora', '1 a 3 horas', '4 a 6 horas', '7 ou mais horas'],
    },
    {
        id: 'q17',
        text: 'Imagine uma plataforma onde você pudesse facilmente encontrar, guardar e compartilhar materiais didáticos com colegas. Quais funcionalidades seriam mais valiosas para você?',
        type: 'Resposta aberta',
    },
    {
        id: 'q18',
        text: 'Qual das seguintes funcionalidades seria a mais importante para você em uma plataforma de apoio a professores para gestão dos materiais de aula?',
        type: 'Única escolha',
        options: [
            'Materiais prontos para impressão',
            'Ferramentas de organização de planos de aula',
            'Habilidade de compartilhar meus próprios materiais',
            'Fórum/Comunidade de professores',
            'Avaliações e comentários de outros professores sobre os materiais',
            'Outra:',
        ]
    },
    {
        id: 'q19',
        text: 'Tendo em vista a resposta anterior, quais das seguintes ferramentas você considera mais valiosas para essa plataforma? (Escolha até 5)',
        type: 'Múltipla escolha',
        options: [
            'Filtros por série, turma, disciplina e BNCC',
            'Filtro por atividade por aluno',
            'Dashboard de acompanhamento dos status de atividades',
            'Materiais prontos para impressão',
            'Edição/adaptação de atividades de outros professores',
            'Edição/adaptacao de atividades em upload na plataforma',
            'Avaliações e comentários nos materiais',
            'Recomendações personalizadas de novos materiais ou habilidades',
            'Planejamento semanal de aulas por turma, alunos, habilidades',
            'Banco de atividades por tema',
            'Colaboração com outros professores',
            'IA para gerar atividades',
        ]
    },
    {
        id: 'q20',
        text: 'Quão disposto(a) você estaria a contribuir com seus próprios planos de aula ou materiais para uma plataforma compartilhada para outros professores usarem?',
        type: 'Única escolha',
        options: ['Muito, totalmente', 'Sim', 'Em parte', 'Não', 'Ainda não usei'],
    },
    {
        id: 'q21',
        text: 'Atualmente, quanto você gasta (se gasta) em recursos educacionais ou assinaturas por mês para suas aulas?',
        type: 'Única escolha',
        options: ['R$0', 'R$1 - R$20', 'R$21 - R$50', 'R$51 - R$100', 'Mais de R$100'],
    },
    {
        id: 'q22',
        text: 'Se uma plataforma como Sôra pudesse economizar de 3 a 5 horas por semana no seu tempo de preparação de aulas, qual seria uma taxa de assinatura mensal justa para você?',
        type: 'Única escolha',
        options: ['R$0 (Não pagaria)', 'R$10 - R$20', 'R$21 - R$40', 'R$41 - R$60', 'Mais de R$60'],
    }
];

const Survey = () => {
    const [answers, setAnswers] = useState({});
    const [outraValues, setOutraValues] = useState({});
    const [showSuccessAlert, setShowSuccessAlert] = useState(false);
    const [showErrorAlert, setShowErrorAlert] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleTextChange = (qId, value) => {
        setAnswers((prev) => ({ ...prev, [qId]: value }));
    };

    const handleMultiChoiceChange = (qId, option, isChecked) => {
        setAnswers((prev) => {
            const current = prev[qId] || [];
            if (isChecked) {
                return { ...prev, [qId]: [...current, option] };
            } else {
                return { ...prev, [qId]: current.filter((item) => item !== option) };
            }
        });
    };

    const handleSingleChoiceChange = (qId, option) => {
        setAnswers((prev) => ({ ...prev, [qId]: option }));
    };

    const handleOutraValueChange = (qId, value) => {
        setOutraValues((prev) => ({ ...prev, [qId]: value }));
        const baseOption = "Outra:";
        // If it's a multi-choice that has 'Outra:', we just keep 'Outra:' in answers and append detail at submission or keep track separately.
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setShowErrorAlert(false);

        const finalAnswers = { ...answers };
        for (const [qId, textValue] of Object.entries(outraValues)) {
            if (!textValue) continue;
            if (Array.isArray(finalAnswers[qId])) {
                finalAnswers[qId] = finalAnswers[qId].map(ans =>
                    ans === 'Outra:' ? `Outra: ${textValue}` : ans
                );
            } else if (finalAnswers[qId] === 'Outra:') {
                finalAnswers[qId] = `Outra: ${textValue}`;
            }
        }

        const formattedAnswers = Object.keys(finalAnswers).map(qId => {
            const questionText = surveyQuestions.find(q => q.id === qId)?.text || '';
            return {
                questionId: qId,
                questionText: questionText,
                answer: finalAnswers[qId]
            };
        });

        try {
            await submitSurvey(formattedAnswers, 'v1');
            setShowSuccessAlert(true);
            setAnswers({});
            setOutraValues({});
            window.scrollTo(0, 0);
        } catch (error) {
            setShowErrorAlert(true);
            console.error(error);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <DashboardLayout title="Enviar opinião">
            <ReducedContent>
                {showSuccessAlert && (
                    <Alert variant="success" onClose={() => setShowSuccessAlert(false)} dismissible>
                        Sua resposta foi enviada com sucesso! Obrigado!
                    </Alert>
                )}
                {showErrorAlert && (
                    <Alert variant="danger" onClose={() => setShowErrorAlert(false)} dismissible>
                        Erro ao enviar resposta. Tente novamente mais tarde.
                    </Alert>
                )}
                <form onSubmit={handleSubmit}>
                    {surveyQuestions.map((q) => {
                        if (q.condition && !q.condition(answers)) return null;

                        return (
                            <div key={q.id} className="mb-4 p-3 border rounded shadow-sm bg-white">
                                <label className="fw-bold mb-3 d-block">{q.text}</label>

                                {q.type === 'Resposta aberta' && (
                                    <textarea
                                        className="form-control"
                                        rows="3"
                                        value={answers[q.id] || ''}
                                        onChange={(e) => handleTextChange(q.id, e.target.value)}
                                    ></textarea>
                                )}

                                {q.type === 'Múltipla escolha' && (
                                    <div className="d-flex flex-column gap-2">
                                        {q.options.map((opt) => (
                                            <div key={opt} className="form-check">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    id={`${q.id}-${opt}`}
                                                    checked={(answers[q.id] || []).includes(opt)}
                                                    onChange={(e) => handleMultiChoiceChange(q.id, opt, e.target.checked)}
                                                />
                                                <label className="form-check-label" htmlFor={`${q.id}-${opt}`}>
                                                    {opt}
                                                </label>
                                                {opt === 'Outra:' && (answers[q.id] || []).includes('Outra:') && (
                                                    <input
                                                        type="text"
                                                        className="form-control mt-2"
                                                        placeholder="Especifique..."
                                                        value={outraValues[q.id] || ''}
                                                        onChange={(e) => handleOutraValueChange(q.id, e.target.value)}
                                                    />
                                                )}
                                            </div>
                                        ))}
                                    </div>
                                )}

                                {(q.type === 'Única escolha' || q.type === 'Escala') && (
                                    <div className={"d-flex gap-3 " + (q.type === 'Única escolha' ? 'flex-column' : 'flex-wrap')}>
                                        {q.options.map((opt) => (
                                            <div key={opt} className="form-check">
                                                <input
                                                    className="form-check-input"
                                                    type="radio"
                                                    name={q.id}
                                                    id={`${q.id}-${opt}`}
                                                    checked={answers[q.id] === opt}
                                                    onChange={() => handleSingleChoiceChange(q.id, opt)}
                                                />
                                                <label className="form-check-label" htmlFor={`${q.id}-${opt}`}>
                                                    {opt}
                                                </label>
                                                {opt === 'Outra:' && answers[q.id] === 'Outra:' && (
                                                    <input
                                                        type="text"
                                                        className="form-control mt-2"
                                                        placeholder="Especifique..."
                                                        value={outraValues[q.id] || ''}
                                                        onChange={(e) => handleOutraValueChange(q.id, e.target.value)}
                                                    />
                                                )}
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        );
                    })}

                    <button type="submit" className="btn btn-primary px-4 py-2 mt-2" disabled={isSubmitting}>
                        {isSubmitting ? 'Enviando...' : 'Enviar Respostas'}
                    </button>
                </form>
            </ReducedContent>
        </DashboardLayout>
    );
};

export default Survey;
